import { call, put, takeLatest, select } from 'redux-saga/effects';
import TicketDetailAction, { TicketDetailTypes } from "redux/actions/ticketDetailAction";
import TicketServices, {
  getActivities,
  getApprovalDetail,
  getTicketDetail
} from 'services/ticketServices';
import BaseAction from '../actions/baseAction';
import OnBehalfAction from '../actions/onBehalfAction';
import { ResourceType } from '../../components/MenuTicket/types';
import { RootState } from 'redux/store';

export function* fetchTicketDetail(action: any): any {
  const { isTicket, params } = action;
  try {
    let result;
    if (isTicket !== ResourceType.Approvals) {
      result = yield call(getTicketDetail, isTicket, params);
    } else {
      result = yield call(getApprovalDetail, params);
    }

    if (result.status === 200) {
      yield put(OnBehalfAction.uptimeAuditLog({
        action: 'VIEW',
        type: 'ticket',
        detail: result.data?.number,
      }));
      yield put(TicketDetailAction.fetchTicketDetailSuccess(!!result.data ? result.data : {}));
    }
  } catch (error) {
    yield put(TicketDetailAction.fetchTicketDetailFail());
    yield put(BaseAction.errorHandling({
      message: `FETCH_TICKET_DETAIL ${error}`
    }));
  }
}

export function* fetchAttachmentsTicket(action: any): any {

  try {
    const { ticketId, isINCTicket, requestItemId } = action;
    let result;
    if (isINCTicket) {
      result = yield call(TicketServices.getAttachmentsTicket, ticketId,'', isINCTicket);      
    } else {
      result = yield call(TicketServices.getAttachmentsTicket, requestItemId, ticketId, isINCTicket);   
    };
    yield put(TicketDetailAction.fetchAttachmentsTicketSuccess(result));
  } catch (error) {
    yield put(TicketDetailAction.fetchAttachmentsTicketFail());
    yield put(BaseAction.errorHandling({
      message: `FETCH_ATTACHMENTS_TICKET ${error}`
    }));
  }
}

export function* fetchActivities(action: any): any {
  try {
    const { isTicket, ticketId } = action;
    const result = yield call(getActivities, isTicket, ticketId);
    yield put(TicketDetailAction.fetchActivitiesSuccess(result));
  } catch (error) {
    yield put(TicketDetailAction.fetchActivitiesFail());
    yield put(BaseAction.errorHandling({
      message: `FETCH_ACTIVITIES ${error}`
    }));
  }
}

export function* provideComment(action: any): any {
  try {
    const { isTicket, ticketId, user_name, keyComment, activeTab, requestItemId, ticketNumber, user_id } = action;

    const state: RootState = yield select();
    const { configReducer } = state;
    const generalConfig = configReducer?.generalConfig;
    const isAddCommentHasUserName = generalConfig?.isAddCommentHasUserName || false;
    const userName = isAddCommentHasUserName ? user_name : '';

    const result = yield call(TicketServices.provideComment, isTicket, ticketId, userName, keyComment, activeTab);
    if (result.status === 200) {
      if (activeTab !== ResourceType.Approvals) {
        yield put(TicketDetailAction.fetchActivities(isTicket, ticketId));  
        if (ticketNumber){
          yield put(TicketDetailAction.fetchTicketDetail(isTicket, {
            ticketNumber: ticketNumber,
            userName: user_name,
          }, false));
        }
      }
      else {
        yield put(TicketDetailAction.fetchActivities(isTicket, requestItemId));
        if (ticketId){
          yield put(TicketDetailAction.fetchTicketDetail(ResourceType.Approvals, {
            uid: ticketId,
            user_name: user_name,
            user_sys_id: user_id,
          }, false));
        }
      } 
    }
  } catch (error) {
    yield put(BaseAction.errorHandling({
      message: `PROVIDE_COMMENT ${error}`
    }));
  }
}

export function* ticketPostAttachment(action: any): any {
  try {
    const { isTicket, ticketId, files, activeTab, ticketNumber, user_id, user_name, requestItemId } = action;
    let result: any = {};
    let resultPostAttachmentApproval: any = {};
    if (isTicket === 'INC') {
      result = yield call(TicketServices.postAttachmentsIncident,
        {
          id: ticketId,
          name: files[0].name,
          type: files[0].type,
        },
        files[0]
      );
    } else {
      if (activeTab !== ResourceType.Approvals) {
        result = yield call(TicketServices.postAttachmentsRequest,
          {
            id: requestItemId,
            name: files[0].name,
            type: files[0].type,
          },
          files[0],
        );
      }
      else{
        resultPostAttachmentApproval = yield call(TicketServices.postAttachmentApproval,
        {
          id: ticketId,
          name: files[0].name,
          type: files[0].type,
        },
        files[0],
        );
      }
    }
    
    if (result.status === 200 || resultPostAttachmentApproval.status === 200) {
      const data = result.data || resultPostAttachmentApproval.data;
      if (!data?.success) {
        yield put(TicketDetailAction.ticketPostAttachmentFail(data?.message));
        return;
      }

      let resultApi = null;

      if (isTicket === 'INC') {
        resultApi = yield call(TicketServices.getAttachmentsTicket, ticketId, '',isTicket === 'INC');
        yield put(TicketDetailAction.fetchAttachmentsTicketSuccess(resultApi));
        const response = yield call(getActivities, isTicket, ticketId);
        yield put(TicketDetailAction.fetchActivitiesSuccess(response));
        if(!!response){
          if (ticketNumber){
            yield put(TicketDetailAction.fetchTicketDetail(isTicket, {
              ticketNumber: ticketNumber,
              userName: user_name,
            }));
          }
        }
      } else {
        resultApi = yield call(TicketServices.getAttachmentsTicket, requestItemId, ticketId, false);
        yield put(TicketDetailAction.fetchAttachmentsTicketSuccess(resultApi));
        const response = yield call(getActivities, isTicket, requestItemId);
        yield put(TicketDetailAction.fetchActivitiesSuccess(response));
        if(!!response){
          if (ticketId){
            if(activeTab === ResourceType.Approvals) {
              yield put(TicketDetailAction.fetchTicketDetail(ResourceType.Approvals, {
                uid: ticketId,
                user_name: user_name,
                user_sys_id: user_id,
              }));
            } else {
              yield put(TicketDetailAction.fetchTicketDetail(isTicket, {
                ticketNumber: ticketNumber,
                userName: user_name,
              }));
            }
          }
        }
      }
      yield put(TicketDetailAction.ticketPostAttachmentSuccess({}));
    }
  } catch (error) {
    yield put(TicketDetailAction.ticketPostAttachmentFail());
    yield put(BaseAction.errorHandling({
      message: `TICKET_POST_ATTACHMENT ${error}`
    }));
  }
}

export const watchTicketDetail = [
  takeLatest(TicketDetailTypes.FETCH_TICKET_DETAIL, fetchTicketDetail),
  takeLatest(TicketDetailTypes.FETCH_ATTACHMENTS_TICKET, fetchAttachmentsTicket),
  takeLatest(TicketDetailTypes.FETCH_ACTIVITIES, fetchActivities),
  takeLatest(TicketDetailTypes.PROVIDE_COMMENT, provideComment),
  takeLatest(TicketDetailTypes.TICKET_POST_ATTACHMENT, ticketPostAttachment)
]
